import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=6ecefb5c"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"
import style0 from "./create-user.vue?vue&type=style&index=0&id=6ecefb5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports